module.exports = __webpack_public_path__ + "img/icon_tip_arrow.979343b3.svg";